import { boot } from 'quasar/wrappers'
import { Chart, registerables } from 'chart.js'
import zoomPlugin from 'chartjs-plugin-zoom';

// "async" is optional;
// more info on params: https://v2.quasar.dev/quasar-cli/boot-files
export default boot((/* { app, router, ... } */) => {
  Chart.register(...registerables)
  Chart.register(zoomPlugin);
})
